import HttpStatusCode from "./HttpStatusCode";

export type KokattoErrorResponse = {
  statusCode?: HttpStatusCode;
  error?: string;
  message?: string;
  status?: string;
  reason?: string;
  statusMessage?: string;
  meta?: Record<string, unknown>;
};

export function isKokattoErrorResponse(
  response: any
): response is KokattoErrorResponse {
  return (
    (response as KokattoErrorResponse).statusCode !== undefined &&
    (response as KokattoErrorResponse).statusCode != 200 &&
    (response as KokattoErrorResponse).statusCode != 201 &&
    ((response as KokattoErrorResponse).reason !== undefined ||
      (response as KokattoErrorResponse).message !== undefined)
  );
}

/**
 * * Specifically Check Error from CIS
 * * CIS Only have statusCode, error, message - No Attribute "reason"
 * @param response
 * @returns
 */
export function isCISErrorResponse(
  response: any
): response is KokattoErrorResponse {
  return !!(response as KokattoErrorResponse).error;
}
